import { Gamecloud } from "../../../../gamecloud";
import { PresetUI } from "./presetUI";

export class Preset extends Gamecloud {

  // UI
  private ui: PresetUI = new PresetUI();
  private type: string = this.ui.typeElement.val() as string;
  private preset: string = this.ui.presetElement.val() as string;

  public constructor(private render: (data, afterRender: () => void) => {}, private extraData, private form, private updateValues: (data) => void, private afterRender: () => void) {
    super();

    if (typeof extraData.extraData.cfgData !== 'undefined') {
      this.bind();
      this.handlePresetChange(this.preset);
      this.handleTypeChange(this.type);
    }
  }

  private bind() {
    this.ui.onPresetChange(this.handlePresetChange.bind(this));
    this.ui.onTypeChange(this.handleTypeChange.bind(this));
  }

  private handlePresetChange(preset: string) {
    this.preset = preset;
    this.handleChange();
  }

  private handleTypeChange(type: string) {
    this.type = type;
    this.handleChange();
  }

  private handleChange() {
    if (typeof this.extraData.sections.extended !== "undefined") {
      let data: any;
      if (this.ui.isBF3()) {
        data = this.extraData.extraData.cfgData[this.preset];
      } else {
        data = this.extraData.extraData.cfgData[this.type + '_' + this.preset];
      }
      this.extraData.sections.extended.variables = data.variables;
      this.updateValues(this.createDataSet(data.variables));
    }
  }

  private createDataSet(data) {
    const newData = { server: {} };
    for (const key in data) {
      if (data.hasOwnProperty(key)) {
        const element = data[key];
        if (element.readOnly === true) {
          newData.server[element.name] = element.default;
          const selector = "[name='config[server][" + element.name + "]']";
          if (this.preset.toLowerCase() !== 'custom') {
            if ($(selector).parents('.fancy-checkbox').length > 0) {
              $(selector).parents('.fancy-checkbox').addClass('is-disabled');
            }
            $(selector).attr('disabled', 'disabled');
          } else {
            if ($(selector).parents('.fancy-checkbox').length > 0) {
              $(selector).parents('.fancy-checkbox').removeClass('is-disabled');
            }
            $(selector).removeAttr('disabled');
          }
        }
      }
    }

    return newData;
  }
}
